import { createSelector } from 'reselect'
import appSelectors from 'src/App/selectors'

const selectWidget = state => state.widget
const selectBehavior = createSelector(selectWidget, stateWidget => stateWidget.behavior)
const selectTheme = createSelector(selectWidget, stateWidget => stateWidget.theme)
const selectStyles = createSelector(selectWidget, stateWidget => stateWidget.styles)
const selectMessages = createSelector(selectWidget, stateWidget => stateWidget.messages)

const makeBehaviorSelector = (fieldPath) => createSelector(
  selectBehavior,
  behaviorState => behaviorState.getIn(fieldPath)
)

const selectIsLive= createSelector(state => state.bot, stateBot => stateBot.isLive)
const selectIsFetching = makeBehaviorSelector(['isFetching'])
const selectInputDisabled = makeBehaviorSelector(['inputDisabled'])
const selectBlink = makeBehaviorSelector(['blink'])
const selectBlinkColor = makeBehaviorSelector(['blinkColor'])
const selectDropdownInput = makeBehaviorSelector(['dropdownInput'])
const selectDropdownOptions = makeBehaviorSelector(['dropdownOptions'])
const selectDateInput = makeBehaviorSelector(['dateInput'])
const selectSenderPlaceholder = makeBehaviorSelector(['senderPlaceHolder']) || makeBehaviorSelector(['defaultSenderPlaceHolder'])
const selectShowTOC = makeBehaviorSelector(['showTOC'])
const selectClearInput = makeBehaviorSelector(['clearInput'])

const embedded = (state, props) => props.config.embedded

const selectShowChat = createSelector(
  makeBehaviorSelector(['showChat']), appSelectors.initialized, embedded,
  (show, initialized, embedded) => show && (embedded || initialized)
)

const selectMenuItems = createSelector(
  selectWidget,
  widget => widget.menu.get('buttons')
)

const selectTocItems = createSelector(
  selectWidget,
  widget => widget.toc.get('buttons')
)

export default {
  selectIsFetching,
  selectIsLive,
  selectBlink,
  selectBlinkColor,
  selectInputDisabled,
  selectDropdownInput,
  selectDropdownOptions,
  selectDateInput,
  selectShowChat,
  selectTheme,
  selectStyles,
  selectMessages,
  selectSenderPlaceholder,
  selectShowTOC,
  selectMenuItems,
  selectTocItems,
  selectClearInput
}



// WEBPACK FOOTER //
// ./src/ChatWidget/store/selectors.js